module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-3.60dfc631.jpg";